<template>
  <div v-if="!loading" class="flex flex-col">
    <div class="flex items-center space-x-4">
      <router-link :to="{ name: 'productsIndex' }" class="system-button">
        <arrow-icon class="w-4 fill-current rotate-90"></arrow-icon>
      </router-link>
    </div>

    <div v-if="product" class="grid grid-cols-1 gap-4 lg:grid-cols-3 mt-2">
      <div class="col-span-1">
        <!-- <div v-if="product.images.length > 0" class="flex flex-col mr-4">
          <div
            v-for="image in product.images"
            :key="image.id"
            :class="[
              'w-10 h-10 rounded mb-2',
              { 'border border-black': selectedImage.id === image.id },
            ]"
            @mouseover="selectedImage = image"
            @click="selectedImage = image"
          >
            <img
              :src="image.url"
              alt=""
              class="w-full h-full rounded object-cover object-center bg-white"
            />
          </div>
        </div> -->

        <!-- <img
          :src="getSelectedImage()"
          alt=""
          class="rounded-lg w-80 h-80 object-contain object-center bg-white"
        /> -->

        <div class="w-full aspect-square bg-white rounded-lg">
          <img
            class="rounded-lg object-contain object-center w-full h-full"
            :src="getSelectedImage()"
          />
        </div>
      </div>

      <div class="lg:col-span-2 h-fit card">
        <card-header :title="product.name">
        </card-header>

        <div class="detail-grid mb-4">
          <detail-field label="SKU" :value="product.sku" />
          <detail-field label="Precio" :value="integerToCurrency(product.unit_price)" :prominent="true" />
          <detail-field label="Categorías">
            <div class="flex flex-wrap gap-2 mt-0.5">
              <p
                v-for="category in product.product_categories"
                :key="category.id"
                class="text-sm text-primary-500"
              >
                {{ category.name }}
              </p>
            </div>
          </detail-field>
          <detail-field label="Descripción" :value="product.description" />
          <detail-field label="Inventario">
            <p
              :class="[
                'detail-value font-medium',
                { 'text-success-600': product.stock > 0 },
                { 'text-error-500': product.stock <= 0 },
              ]"
            >
              {{ product.stock }} en inventario
            </p>
          </detail-field>
        </div>
        <div class="flex flex-col w-full mt-2">
          <label for="quantity">Cantidad</label>
          <input id="quantity" type="number" v-model="product.quantity" />
          <p
            class="text-error-500"
            v-if="product.quantity + getQuantityInCart() > product.stock"
          >
            Cantidad no disponible
          </p>
        </div>
        <primary-button
          v-if="
            product.quantity > 0 &&
            product.quantity + getQuantityInCart() <= product.stock
          "
          class="mt-4 mx-0"
          @buttonClicked="addToCart()"
        >
          Agregar al Carrito
        </primary-button>
      </div>
    </div>
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import api from "@/api";
import { integerToCurrency } from "@/utils/currencyFormatter";
import { mapState } from "vuex";
export default {
  name: "Products",

  data() {
    return {
      product: null,
      loading: false,
      defaultImage: require("@/assets/paw.png"),
      quantity: 1,
    };
  },

  computed: {
    ...mapState({
      cart: "cart",
    }),
  },

  created() {
    this.$store.commit("setSelectedTab", "products");

    this.loadProduct();
  },

  methods: {
    integerToCurrency,

    async loadProduct() {
      this.loading = true;

      try {
        this.product = await api.resources.getProductById(
          this.$route.params.id
        );

        this.selectedImage = this.product.images[0];
        this.product.quantity = 1;
        this.$store.commit('setBreadcrumbLabel', {
          routeName: this.$route.name,
          label: this.product.name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getSelectedImage() {
      if (!this.product.image_url) {
        return this.defaultImage;
      }

      return this.product.image_url;
    },

    getQuantityInCart() {
      let product = this.cart.products.filter(
        (product) => product.id === this.product.id
      )[0];

      return product ? product.quantity : 0;
    },

    addToCart() {
      this.$store.dispatch("addToCart", this.product);

      this.$router.push({ name: "cart" });
    },
  },
};
</script>